import { Facebook, Instagram, Linkedin, Youtube } from 'lucide-react';

/**
 * Uses lucide rather than brand marks: LinkedIn (like AWS) has been
 * withdrawn from Simple Icons on trademark grounds, and mixing one
 * outline icon into three solid brand marks looks broken. One family
 * keeps the row consistent.
 */
const SOCIALS = [
  {
    icon: Linkedin,
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/company/inafana-co',
  },
  {
    icon: Youtube,
    label: 'YouTube',
    href: 'https://www.youtube.com/@Inafana-SoftwareSolutions',
  },
  {
    icon: Instagram,
    label: 'Instagram',
    href: 'https://www.instagram.com/_inafana/',
  },
  {
    icon: Facebook,
    label: 'Facebook',
    href: 'https://www.facebook.com/p/Inafana-61574232467709/',
  },
] as const;

export function Socials(): React.JSX.Element {
  return (
    <ul className="socials">
      {SOCIALS.map((s) => (
        <li key={s.label}>
          <a
            href={s.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Inafana on ${s.label}`}
          >
            <s.icon size={17} strokeWidth={1.9} aria-hidden="true" />
          </a>
        </li>
      ))}
    </ul>
  );
}
